export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "pl-PL",
    "Messages": {
        "3": "",
        "4": "",
        "5": "",
        "8": "",
        "10": "",
        "12": "",
        "16": "",
        "20": "",
        "24": "",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "",
        "Aby dodawać stanowiska musisz najpierw zapisać formularz.": "",
        "Aby dodawać wydziały musisz najpierw zapisać formularz.": "",
        "Akceptuj": "",
        "Aktualizacja": "",
        "anuluj": "",
        "Anuluj": "",
        "Automatyczna publikacja ogłoszeń": "",
        "Baza ogłoszeń": "",
        "Baza PDF": "",
        "Brak stron": "",
        "Cena": "",
        "Czekające na akceptację": "",
        "Członkowie zespołu": "",
        "Data do": "",
        "Data dodania": "",
        "Data modyfikacji": "",
        "Data od": "",
        "Data ogłoszenia do": "",
        "Data ogłoszenia od": "",
        "Data opuszczenia zespołu": "",
        "Data publikacji": "",
        "Data rozpoczęcia": "",
        "Data zakończenia": "",
        "Daty publikacji zostały zaktualizowane.": "",
        "Dodaj": "",
        "Dodaj do zespołu": "",
        "Dodaj kategorię": "",
        "Dodaj ofertę": "",
        "Dodaj ogłoszenie": "",
        "Dodaj PDF": "",
        "Dodaj rodzaj ogłoszenia": "",
        "Dodaj stronę": "",
        "Dodaj tylko pracowników z wybranych wydziałów": "",
        "Dodaj zasób": "",
        "Dodane przez": "",
        "Dodane przeze mnie": "",
        "Dodanie kategorii": "",
        "Dodanie oferty": "",
        "Dodanie ogłoszenia": "",
        "Dodanie PDF": "",
        "Dodanie rodzaju": "",
        "Dodanie zasobu": "",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "",
        "Dokument nie ma ustawionej daty publikacji.": "",
        "Edycja kategorii": "",
        "Edycja oferty": "",
        "Edycja ogłoszenia": "",
        "Edycja PDF": "",
        "Edycja rodzaju": "",
        "Edycja zasobu": "",
        "Edytuj": "",
        "Edytuj członka grupy": "",
        "Erecruiter": "",
        "Firma": "",
        "Galeria zdjęć": "",
        "Generowanie stron gazetek...": "",
        "Generuj strony gazetki": "",
        "Id": "",
        "ID": "",
        "Ilość ogłoszeń w kategorii": "",
        "Ilość zasobów w kategorii": "",
        "Imię": "",
        "Imię i Nazwisko": "",
        "Inspekcja": "",
        "Język": "",
        "Kategoria": "",
        "Kategoria została dodana.": "",
        "Kategoria została usunięta.": "",
        "Kategoria została zaktualizowana.": "",
        "Kategorie ogłoszeń": "",
        "Kategorie zasobów": "",
        "Konta użytkowników": "",
        "Liczba wyników na stronie": "",
        "Liczba wyświetlanych dokumentów": "",
        "Liczba wyświetlanych galerii": "",
        "Liczba wyświetlanych najnowszych elementów": "",
        "Liczba wyświetlanych nowych pracowników": "",
        "Liczba wyświetlanych ogłoszeń": "",
        "Link do aplikowania": "",
        "Link do oferty": "",
        "Link do strony": "",
        "Lista jest pusta": "",
        "Lista rezerwacji": "",
        "Login": "",
        "Miasto": "",
        "Moduły": "",
        "Multimedia": "",
        "Nazwa": "",
        "Nazwa kategorii": "",
        "Nazwa stanowiska": "",
        "Nazwa użytkownika": "",
        "Nazwa zespołu": "",
        "Nazwisko": "",
        "Nie": "",
        "Nie można zaakceptować wybranej rezerwacji. Wybrany termin jest już zajęty.": "",
        "Nie udało się pobrać listy kategorii": "",
        "Nie udało się pobrać listy rezerwacji": "",
        "Nie udało się pobrać listy rodzajów": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy stanowisk": "",
        "Nie udało się pobrać listy wydziałów": "",
        "Nie udało się pobrać listy zasobów": "",
        "Nie zdefiniowano żadnych ról.": "",
        "Nie znaleziono żadnych użytkowników.": "",
        "Nie znaleziono żadnych wyników.": "",
        "Nowy dokument": "",
        "Numer referencyjny": "",
        "Odrzucone": "",
        "Odrzuć": "",
        "Oferta została dodana.": "",
        "Oferta została usunięta.": "",
        "Oferta została zaktualizowana.": "",
        "Oferty pracy - Import": "",
        "Ogłoszenia": "",
        "Ogłoszenie": "",
        "Ogłoszenie nie jest jeszcze nigdzie opublikowane.": "",
        "Ogłoszenie nie ma ustawionej daty publikacji.": "",
        "Ogłoszenie zostało dodane.": "",
        "Ogłoszenie zostało usunięte.": "",
        "Ogłoszenie zostało zaktualizowane.": "",
        "Opiekun": "",
        "Opis": "",
        "Opis zespołu": "",
        "Opublikuj": "",
        "PDF": "",
        "PDF nie jest jeszcze nigdzie opublikowany.": "",
        "PDF nie ma ustawionej daty publikacji.": "",
        "PDF został dodany.": "",
        "PDF został usunięty.": "",
        "PDF został zaktualizowany.": "",
        "Plik PDF": "",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "",
        "Pochodzenie": "",
        "Pole \"Email\" jest wymagane.": "",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "",
        "Pole nie może zawierać spacji": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdź akceptację": "",
        "Powiązane stanowiska": "",
        "Powiązane wydziały": "",
        "Powód odrzucenia rezerwacji": "",
        "Powrót": "",
        "Publikacja": "",
        "Publikacja ogłoszeń przez użytkownika": "",
        "Publikacja została dodana.": "",
        "Publikacja została usunięta.": "",
        "Publikuj do": "",
        "Publikuj od": "",
        "Regulaminy": "",
        "Rezerwacja zasobów": "",
        "Rezerwacja została odrzucona.": "",
        "Rezerwacja została usunięta.": "",
        "Rezerwacja została zaakceptowana.": "",
        "Rodzaj": "",
        "Rodzaj ogłoszenia": "",
        "Rodzaj ogłoszenia został dodany.": "",
        "Rodzaj ogłoszenia został usunięty.": "",
        "Rodzaj ogłoszenia został zaktualizowany.": "",
        "Rodzaje ogłoszeń": "",
        "Role użytkownika": "",
        "Role zespołu": "",
        "Stanowiska": "",
        "Stanowisko": "",
        "Stanowisko zostało dodane.": "",
        "Stanowisko zostało usunięte.": "",
        "Status": "",
        "Status oferty został zmieniony.": "",
        "Status ogłoszenia został zmieniony.": "",
        "Status PDF został zmieniony.": "",
        "Strona": "",
        "Strona z modułu baza dokumentów": "",
        "Strony gazetki": "",
        "Studio": "",
        "System": "",
        "Tagi": "",
        "Tak": "",
        "Ten zespół nie posiada jeszcze żadnych powiązanych stanowisk": "",
        "Ten zespół nie posiada jeszcze żadnych powiązanych wydziałów": "",
        "Tokeny": "",
        "Uprawnienia": "",
        "Ustawienia": "",
        "Ustawienia konta": "",
        "Ustawienia ogłoszeń": "",
        "Ustawienia zostały zapisane.": "",
        "Usuń": "",
        "Usuń z zespołu": "",
        "Użytkownik jest liderem zespołu": "",
        "Użytkownik posiada pełne uprawnienia": "",
        "Użytkownik został dodany do zespołu.": "",
        "Użytkownik został dodany.": "",
        "Użytkownik został zaktualizowany.": "",
        "W zespole od %0": "",
        "W zespole od %0 do %1": "",
        "Wersje": "",
        "Właściwości": "",
        "Województwo": "",
        "Wpis został zaktualizowany.": "",
        "Wszyscy użytkownicy": "",
        "Wszystkie": "",
        "Wszystkie języki": "",
        "Wybierz": "",
        "Wybierz autora": "",
        "Wybierz opiekuna": "",
        "Wybierz stanowisko": "",
        "Wybierz stronę": "",
        "Wybierz strony": "",
        "Wybierz użytkownika": "",
        "Wybierz wydział": "",
        "Wybór języka": "",
        "Wybór listy stron": "",
        "Wybór listy stron artykułów": "",
        "Wybór listy stron galerii": "",
        "Wybór listy stron ogłoszeń": "",
        "Wybór strony": "",
        "Wybrane": "",
        "Wybranie strony jest wymagane": "",
        "Wydział": "",
        "Wydział został dodany.": "",
        "Wydział został usunięty.": "",
        "Wydziały": "",
        "Wymagaj wszystkich warunków": "",
        "Wymagana akceptacja": "",
        "zacznij pisać aby wyszukać autora...": "",
        "zacznij pisać aby wyszukać opiekuna...": "",
        "zacznij pisać aby wyszukać stanowisko...": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "zacznij pisać aby wyszukać wydział...": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zarezerwował": "",
        "Zarezerwowane": "",
        "Zasoby": "",
        "Zasób": "",
        "Zasób aktywny": "",
        "Zasób nie jest jeszcze nigdzie opublikowany.": "",
        "Zasób został dodany.": "",
        "Zasób został usunięty.": "",
        "Zasób został zaktualizowany.": "",
        "Zdjęcie główne": "",
        "Zespoły": "",
        "Zespół aktywny": "",
        "Zespół został dodany.": "",
        "Zespół został usunięty.": "",
        "Zespół został zaktualizowany.": "",
        "Zmień daty publikacji": "",
        "Zmień widok": "",
        "Zobacz wszystkie ogłoszenia": "",
        "Zobacz wszystkie rezerwacje": ""
    }
};
